import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  messages: [],
  chatTitle: '',
  ticketId: null,
  ticketStatus: 'open',
  newTicketOrReply:0
};

const supportTicketSlice = createSlice({
  name: 'supportTicket',
  initialState,
  reducers: {
    setMessageHistory: (state, action) => {
      state.messages = action.payload;
    },
    setTitle: (state, action) => {
      state.chatTitle = action.payload;
    },
    setTicketId: (state, action) => {
      state.ticketId = action.payload;
    },
    setTicketStatus: (state, action) => {
      state.ticketStatus = action.payload;
    },
    setNewTicketOrReply: (state, action) => {
      state.newTicketOrReply = action.payload;
    },
    addMessage: (state, action) => {
      state.messages.push(action.payload);
    },
    clearChat: (state) => {
      state.messages = [];
      state.chatTitle = '';
      state.ticketId = null;
      state.ticketStatus = 'open';
    },
  },
});

export const {
  setMessageHistory,
  setTitle,
  setTicketId,
  setTicketStatus,
  setNewTicketOrReply,
  addMessage,
  clearChat,
} = supportTicketSlice.actions;

export default supportTicketSlice.reducer; 